export default {"src":"/_next/static/media/arrowRightUiLight_24.f4ca1101.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};